<script setup>
import ProfileContainer from "@/Components/ProfileContainer.vue";
import {Link} from '@inertiajs/vue3';
import LegacyLink from "@/Layouts/Partials/LegacyLink.vue";

defineProps({
    title: String,
});
</script>
<template>
    <div class="min-h-screen py-6 bg-gray-50 flex flex-col items-center md:justify-center">
        <LegacyLink />
        <div class="flex flex-col w-full">
            <div class="sm:mx-auto sm:w-full sm:max-w-md">
                <Link href="/">
                    <img class="mx-auto h-24 md:h-36 w-auto"
                         src="/img/ocsf.png"
                         alt="Old Country Store Fabrics"/>
                </Link>
                <h2 class="mt-2 md:mt-6 text-center text-xl leading-9 tracking-tight text-gray-400">{{ title }}</h2>
            </div>

            <div class="mt-4 md:mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]">
                <ProfileContainer>
                    <slot/>
                </ProfileContainer>
            </div>
        </div>
    </div>
</template>
